import { array, object, string } from "yup";

export const serviceTeamCreationSchema = () =>
  object({
    name: string().required("Organisation name is required"),
    country: string().required("Country of registration is required"),
    tag_ids: array().min(1).required("Please select at least one Service"),
  });
